<template>
  <div id="reservations">
    <ul v-if="errors && errors.length">
      <li v-for="error of errors">
        {{error.message}}
      </li>
    </ul>
      <v-data-table
              :items="reservations"
              hide-actions
              :headers="headers"
              class="my-reservations"
              v-if="reservations && reservations.length"
      >
          <template v-slot:items="reservations">
              <td class="text-xs-left">{{ moment(reservations.item.date).format('DD.MM.YYYY') }}</td>
              <td class="text-xs-left" v-text="$t(moment(reservations.item.date).format('dd'))"></td>
              <td class="text-xs-left">{{ reservations.item.startTime }} - {{ reservations.item.endTime }}</td>
              <td class="text-xs-left">{{ reservations.item.court }}</td>
              <td class="text-xs-left">{{ reservations.item.price }}</td>
              <td class="text-xs-right">
                  <div class="button-wrapper">
                      <button v-if="reservations.item.status!='1'" v-on:click="redirectToPayment(reservations.item.id)">{{$t('Pay')}}</button>
                  </div>
              </td>
          </template>
      </v-data-table>
      <div v-else>{{$t('No reservations')}}</div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  data () {
    return {
        reservations: [],
        errors: [],
        headers: [
            {text: this.$t('Date'), sortable: false},
            {text: this.$t('Day'), sortable: false},
            {text: this.$t('Time'), sortable: false},
            {text: this.$t('Court'), sortable: false},
            {text: this.$t('Sum'), sortable: false},
            {text: '', sortable: false}
        ]
    }
  },
  methods: {
    moment,
    redirectToPayment: function(bookingId) {
        window.location.href = this.$apiURL + '/redirectBookingPayment?id=' + bookingId;
    }
  },
  created() {
    axios.get('/getClientBookings')
    .then(response => {
      this.reservations = response.data.data
    })
    .catch(e => {
      //this.errors.push(e);
        if(e.response.status === 401){
            localStorage.removeItem('token');
            this.$router.go(0)
        }
    })
  }
}
</script>

<style lang="scss">
    #reservations {
        max-width: 1000px; margin: 40px auto 0;
        table {
            width: 100%; text-align: left; border-collapse: collapse; margin-bottom: 20px;
            tr {height: 32px;}
            th {background: #ececec; font-size: 1rem; color: #111;}
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/account/Reservations.vue